module.exports = __webpack_public_path__ + "static/west-with-the-night-3bd1aa964c86b1fa5ae514dbf9e124f4.jpg";